// test2520
(2520 && 0);
